import { useState, type JSX } from "react";
import { cn, formatdDate } from "../../lib/utils";
import { useTranslation } from "react-i18next";
import { TooltipCell } from "../table/TooltipCell";
import Badge from "../shared/ui/Badge";
import Modal from "../modal/Modal";

type BodyTableOrderLogsProps = {
  id?: string | null;
  orderDetail: any;
};

export const BodyTableOrderLogs = ({
  orderDetail,
}: BodyTableOrderLogsProps): JSX.Element => {
  const { t } = useTranslation();

  const [errorDetails, setErrorDetails] = useState<any>(null);

  let rows = [...(orderDetail?.logs || [])].reverse() || [];

  const baseCellClassName = cn(
    "p-[12px] typo-body-small-medium-14 text-black  border-b text-sm text-primary-light",
    "align-middle min-w-0",
  );

  return (
    <>
      {rows?.map((log: any, index: number) => {
        let errorlog = null
        if (index !== rows.length - 1) {
          if (!rows[index + 1]?.current_status || !rows[index + 1]?.previous_status) {
            errorlog = rows[index + 1]
          }
        }
        if (!log?.current_status || !log?.previous_status) {
          return null
        }

        return (
          <tr key={index}>
            <td className={cn(baseCellClassName)}>
              <TooltipCell content={formatdDate(log.created_stamp) || '-'} />
            </td>
            <td className={cn(baseCellClassName)}>
              <Badge status={log.current_status} />
            </td>
            <td className={cn(baseCellClassName)}>
              <Badge status={log.previous_status} />
            </td>
            <td className={cn(baseCellClassName, "flex flex-col items-center gap-1")}>
              <Badge status={log.previous_status} />
              <span className="text-blue-400 text-lg -my-2">↓</span>
              <Badge status={log.current_status} />

              {errorlog && <>
                <span className="text-blue-400 text-lg -my-2">↓</span>
                <Badge
                  className="cursor-pointer"
                  status={'error'}
                  leftIcon="error_outline"
                  onClick={() => setErrorDetails(errorlog)}
                />
              </>
              }
            </td>
          </tr>
        );
      })}

      <Modal
        title={t('statuses.error')}
        size="md"
        headerClass='text-[32px] mt-2'
        isOpen={!!errorDetails}
        onClose={() => setErrorDetails(null)}
      >
        <div className="mx-6 mt-3 flex">
          <span className="text-am leading-[22px]">OR-{orderDetail?.his_prescription_id}:&nbsp;</span>
          <span className="text-am font-normal leading-[22px]">{formatdDate(orderDetail?.created_stamp)}</span>
        </div>
        <div className="px-6 my-4 space-y-6 max-h-[500px] overflow-auto">
          <p className="text-sm leading-[22px]">
            {errorDetails?.error_details}
          </p>
        </div>
      </Modal>
    </>
  );
};
